import React from "react";
import TextInput from "src/components/atoms/text-input";
import CustomCard from "src/components/molecules/custom-card";
import CustomSelect from "src/components/atoms/custom-select";
import { Icon } from "src/components/atoms/icons";
import CustomButton from "src/components/atoms/button";

const PersonalInformationComponent = ({
  formik,
  resetError,
  handleSubmit,
  toggle,
}: any) => {
  // Radio button

  const placeholders: any = {
    first_name: "Enter First Name",
    last_name: "Enter Last Name",
    email: "Enter Email Address",
    phone: "ex. +31 123-4567-89",
    display_name: "Enter Display Name",
  };

  // Radio button options
  const options = [
    { value: "admin", label: "Admin" },
    { value: "user", label: "User" },
  ];

  return (
    <CustomCard title="Personal Information">
      <form
        className="grid gap-x-5 gap-y-5 xl:grid-cols-12"
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            handleSubmit();
          }
        }}
      >
        {[
          "first_name",
          "last_name",
          "role",
          "email",
          // "phone",
          "display_name",
        ].map((fieldName) => (
          <div
            key={fieldName}
            className={`col-span-12 grid ${
              fieldName === "phone" ? "lg:col-span-12" : "lg:col-span-6"
            }`}
          >
            {fieldName === "role" ? (
              <CustomSelect
                label="Role"
                name={fieldName}
                placeholder="Select an option"
                options={options}
                value={formik?.values?.[fieldName]}
                showError={Boolean(formik.touched[fieldName])}
                onChange={(e) => {
                  resetError();
                  formik.handleChange(e);
                }}
                onBlur={(e) => {
                  formik.handleBlur(e);
                  resetError();
                }}
                errorMessage={formik.errors[fieldName]}
                allowClear
                required={true}
                disabled={true}
                suffixIcon={<Icon.McsIcDownArrow />}
              />
            ) : (
              <TextInput
                name={fieldName}
                type={
                  fieldName === "email"
                    ? "email"
                    : fieldName === "role"
                      ? "text"
                      : fieldName === "phone"
                        ? "number"
                        : "text"
                }
                label={
                  fieldName === "first_name"
                    ? "First Name"
                    : fieldName === "last_name"
                      ? "Last Name"
                      : fieldName === "role"
                        ? "Role"
                        : fieldName === "email"
                          ? "Email Address"
                          : fieldName === "phone"
                            ? "Phone Number"
                            : "Display Name"
                }
                placeholder={placeholders[fieldName]}
                value={formik?.values?.[fieldName]}
                showError={Boolean(formik.touched[fieldName])}
                onChange={(e) => {
                  resetError();
                  formik.handleChange(e);
                }}
                onBlur={(e) => {
                  formik.handleBlur(e);
                  resetError();
                }}
                errorMessage={formik.errors[fieldName]}
                classes={{
                  containerClassName: "custom-input",
                  inputClassName: "",
                }}
                required={
                  fieldName !== "last_name" &&
                  fieldName !== "phone" &&
                  fieldName !== "display_name"
                }
                disabled={!toggle}
              />
            )}
          </div>
        ))}

        <div className="col-span-12 lg:col-span-6"></div>

        <div className="mt-8" hidden={!toggle}>
          <CustomButton block={false} className="px-16" onClick={handleSubmit}>
            Save
          </CustomButton>
        </div>
      </form>
    </CustomCard>
  );
};

export default PersonalInformationComponent;
